import React from "react";

import { Box, IconButton, useTheme } from "@mui/material";

import logo from '../../../img/menu.svg';

export default function DashboardNavbar({setIsSidebarOpened}) {
    const theme = useTheme();

    function openSidebar() {
        setIsSidebarOpened(true);
    }

    return (
        <Box
            style={{
                height: '40px',
                paddingLeft: '5px',
                backgroundColor: theme.palette.background.secondary,
                borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
            }}
        >
            <IconButton onClick={openSidebar}>
                <img src={logo} />
            </IconButton>
        </Box>
    );
}